import React from 'react';
import Loader from 'react-loader-spinner';

import { Heading3 } from '../../components/Typography';
import {
	ProgramDetails as Container,
	AbleToGeneratePlaylists,
	NoObservations,
	DailyDataFallback,
	StoredOffs,
} from './styles';

import { useMemo } from 'react';

const Infos = ({ contract, script, neededOffs, isCalculatingOffs }) => {
	const offsMessage = useMemo(() => {
		if (isCalculatingOffs) {
			return (
				<DailyDataFallback>
					<Loader type='TailSpin' height={20} width={20} color='#d8b135' />
					<span>Calculando offs necessários</span>
				</DailyDataFallback>
			);
		}

		if (neededOffs === 0) {
			return <StoredOffs>Todos os offs desse dia já foram enviados</StoredOffs>;
		}

		return <NoObservations>Nenhum off enviado nessa data</NoObservations>;
	}, [isCalculatingOffs, neededOffs]);

	if (!script) {
		return (
			<Container>
				<Heading3>Informações</Heading3>
				<span className='empty'>Selecione o programa para ver suas informações</span>
			</Container>
		);
	}

	return (
		<>
			<Container>
				<Heading3>Informações</Heading3>

				<ul>
					<li>
						<span>Offs enviados</span>
						{offsMessage}
					</li>
					<li>
						<span>Programa</span>
						<strong>{contract.value.program.name}</strong>
					</li>

					<li>
						<span>Rádio</span>
						<strong>
							{contract.value.radio.name} {contract.value.radio.surname}
						</strong>
					</li>

					<li>
						<span>É possível criar playlists</span>

						<AbleToGeneratePlaylists able={contract.value.playlistPrivilege}>
							{contract.value.playlistPrivilege ? 'Sim' : 'Não'}
						</AbleToGeneratePlaylists>
					</li>
				</ul>
			</Container>
		</>
	);
};

export default Infos;
